/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import { VApplication } from "../application/index";
import { GET_MY_ROLES } from "../pages/Dashboard/graphql/get-my-roles.query";
import { toast } from "react-hot-toast";
import {getErrorMessage} from "../utils/error.message";

const SERVICE_NAME = "DashboardService.service";
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require("is_js");

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class DashboardService {
    name = SERVICE_NAME;
    private static instance: DashboardService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new DashboardService();
        }
        return this.instance;
    }
    async init() {}

    async getMyRole() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_MY_ROLES,
                    variables: {},
                    fetchPolicy: "network-only",
                });
                if (res?.data?.getMyRole) {
                    const _FENavItems = res?.data?.getMyRole?.FENavItems;
                    let FENavItems: any = _FENavItems ? _FENavItems : [];
                   
                    return {FENavItems};
                }
            }
        } catch (err: any) {
            // err?.graphQLErrors &&
            //     Array.isArray(err?.graphQLErrors) &&
            //     err?.graphQLErrors.length > 0 &&
            //     toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
